import Accordion from "../components/accordion";

function headerDropdownInit(menuItem = '.js-menu-item', subMenu = '.js-sub-menu',
                            btnMob = '.js-nav-btn', menuMob = '.js-nav') {

    const searchIcon = $('.js-header-search'),
        header = $('.header'),
        body = $('body'),
        accordion = new Accordion('.header__nav__item > .nav-link', '.header__nav__item', updateHeight);

    let scroll = $(window).scrollTop(),
        width = $(window).width();

    function navClass(menuItem, subMenu = '.js-sub-menu') {
        let isActive = false,
            activeItem = undefined;

        $(menuItem).each(function (i, el) {
            let sub = $(el).find(subMenu).length > 0 ? $(el).find(subMenu) : $(el).next(subMenu);

            if ($(el).hasClass('active') && !$(sub).hasClass('close')) {
                isActive = true;
                activeItem = $(el);
            }
        });

        if (searchIcon.hasClass('active')) {
            isActive = true;
        }

        if (isActive) {
            header.addClass('open-menu');
            $(activeItem).hasClass('header__products') ? header.addClass('products-active') : header.removeClass('products-active');
        } else {
            header.removeClass
            ('open-menu').removeClass('products-active');

            if ($(window).width() <= 1250) {
                resetHeight();
            }
        }
    }

    function closeItem(sub, item) {
        if ($(item).hasClass('active')) {
            $(sub).addClass('close');

            setTimeout(() => {
                $(item).removeClass('active');
                $(sub).removeClass('open').removeClass('close');
            }, 300);
        }
    }

    function addNavClick(menuItem, subMenu) {

        $(menuItem).each(function (i, el) {
            $(el).on('click', () => {
                if (searchIcon.hasClass('active')) {
                    searchIcon.removeClass('active');
                }

                $(menuItem).each((j, el) => {
                    let sub = ($(el).find(subMenu)).length > 0 ? $(el).find(subMenu) : $(el).next(subMenu);

                    if (i === j && !$(sub).hasClass('open')) {
                        $(sub).addClass('open');
                        $(el).addClass('active');

                        if ($(window).width() <= 1250) {
                            header.addClass('header-fixed');
                            setTimeout(() => {
                                setHeight();
                            }, 600)
                        }
                    } else {
                        closeItem(sub, el);
                    }
                });

                navClass(menuItem, subMenu);
            })
        });
    }

    function addListeners() {
            $(document).on('click', (ev) => {
                let target = $(ev.target), activeItem = $(`${subMenu}.open`);
                if (!target.hasClass(menuItem) && $(menuItem).find(target).length < 1 && activeItem.length > 0 &&
                    !target.hasClass(searchIcon) && $(searchIcon).find(target).length < 1) {
                    closeItem(activeItem, menuItem);
                    navClass(menuItem);
                }
            })

        searchIcon.on('click', function (ev) {
            ev.preventDefault();
            const icon = $(ev.currentTarget),
                activeItem = $(`${subMenu}.open`);
            if (!icon.hasClass('active')) {
                closeItem(activeItem, menuItem);
                icon.addClass('active')
            } else {
                icon.removeClass('active')
            }

            navClass(menuItem);
        })
    }

    function removeHeaderListeners(menuItem = '.js-menu-item', subMenu = '.js-sub-menu') {
        header.removeClass('open-menu').removeClass('products-active');

        $(menuItem).each(function (i, el) {
            let sub = ($(el).find(subMenu)).length > 0 ? $(el).find(subMenu) : $(el).next(subMenu);
            $(sub).removeClass('open').removeClass('close');
            $(el).off('click');
            $(el).removeClass('active');
        });
    }

    function updateHeight () {
        let currentNav = $(`${menuMob}.open`);

        const menuHeight = currentNav.outerHeight(),
            headerHeight = header.outerHeight();
        body.outerHeight(menuHeight + headerHeight);
    }

    function setHeight() {
            scroll = $(window).scrollTop();
            document.querySelector('body').scrollIntoView({block: "start", behavior: "auto"});
            updateHeight();
            header.css({'position': 'absolute'});
    }

    function resetHeight() {
        let curHeight = body.css('height');

            if (curHeight && curHeight !== 'auto') {
                body.outerHeight('auto');
                $(window).scrollTop(scroll);
            }

        header.removeAttr('style');
    }

    if ($(window).width() > 1250) {
        addListeners();
        addNavClick(menuItem, subMenu);
    } else {
        addNavClick(btnMob, menuMob);
        accordion.init();
    }

    $(window).on('resize', function () {
        if (width !== $(window).width()) {
            removeHeaderListeners(btnMob, menuMob);
            removeHeaderListeners(menuItem, subMenu);
            accordion.destroy();

            searchIcon.removeClass('active');
            resetHeight();

            addListeners();
            if ($(window).width() > 1250) {
                addNavClick(menuItem, subMenu);

            } else {
                navClass(menuItem, subMenu);
                addNavClick(btnMob, menuMob);
                accordion.init();
            }
            width = $(window).width();
        }
    })
}

export default headerDropdownInit;